<div class="header">
    <h2>Creazione <strong>Nuovo Utente</strong></h2>
    <div class="breadcrumb-wrapper hidden-xs">
        <ol class="breadcrumb">
            <li><a routerLink="/user">Utenti</a></li>
            <li class="active">Creazione Nuovo Utente</li>
        </ol>
    </div>
</div>
<div class="row">
    <div class="col-lg-12 portlets">
        <div class="panel">
            <div class="panel-content">
                <form (ngSubmit)="onSubmit()" #loginForm="ngForm" role="form" class="form-horizontal form-validation">
                    <div class="form-group">
                        <label for="username" class="col-sm-3 control-label">Username *</label>
                        <div class="col-sm-6 prepend-icon">
                            <input type="text"
                                   id="username"
                                   name="username"
                                   class="form-control"
                                   placeholder="Minimo 3 caratteri..."
                                   minlength="3"
                                   required
                                   autocomplete="off"
                                   [ngClass]="{
                        'form-error': !(username.valid || username.pristine),
                        'form-success': username.valid
                     }"
                                   [(ngModel)]="user.username"
                                   #username="ngModel">
                            <i class="icon-user"></i>
                            <div [hidden]="username.valid || username.pristine"
                                 class="form-error valid">
                                Inserisci almeno 3 caratteri.
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="password" class="col-sm-3 control-label">Password *</label>
                        <div class="col-sm-6 prepend-icon">
                            <input type="password"
                                   id="password"
                                   name="password"
                                   class="form-control"
                                   placeholder="Minimo 3 caratteri..."
                                   minlength="3"
                                   required
                                   autocomplete="off"
                                   [ngClass]="{
                        'form-error': !(password.valid || password.pristine),
                        'form-success': password.valid
                     }"
                                   [(ngModel)]="user.password"
                                   #password="ngModel">
                            <i class="icon-lock"></i>
                            <div [hidden]="password.valid || password.pristine"
                                 class="form-error valid">
                                Inserisci almeno 3 caratteri.
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="col-sm-3 control-label">Ruolo *</label>
                        <div class="col-sm-6" style="padding-top: 10px;">
                            <mat-radio-group id="user-role"
                                             name="user-role"
                                             [color]="'primary'"
                                             [(ngModel)]="user.fk_id_role">
                                <mat-radio-button *ngFor="let role of roles"
                                                  [value]="role.id_role">
                                    <span style="font-weight: 400 !important;">{{ role.value }}</span>
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div *ngIf="user.fk_id_role === 4" class="form-group">
                        <label for="pa" class="col-sm-3 control-label">Fornitore *</label>
                        <div class="col-sm-6">
                            <select class="form-control"
                                    name="pa"
                                    id="pa"
                                    style="width:100%;"
                                    [(ngModel)]="user.fk_id_pa">
                                <option [ngValue]="" disabled selected>Seleziona Fornitore...</option>
                                <option *ngFor="let pa of pas"
                                        [ngValue]="pa.id_pa">{{ pa.name }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="name" class="col-sm-3 control-label">Nome *</label>
                        <div class="col-sm-6 prepend-icon">
                            <input type="text"
                                   id="name"
                                   name="name"
                                   class="form-control"
                                   placeholder="Inserisci Nome..."
                                   required
                                   autocomplete="off"
                                   [ngClass]="{
                        'form-error': !(name.valid || name.pristine),
                        'form-success': name.valid
                     }"
                                   [(ngModel)]="user.name"
                                   #name="ngModel">
                            <i class="icon-user"></i>
                            <div [hidden]="name.valid || name.pristine"
                                 class="form-error valid">
                                Il nome è richiesto.
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="surname" class="col-sm-3 control-label">Cognome *</label>
                        <div class="col-sm-6 prepend-icon">
                            <input type="text"
                                   id="surname"
                                   name="surname"
                                   class="form-control"
                                   placeholder="Inserisci Cognome..."
                                   required
                                   autocomplete="off"
                                   [ngClass]="{
                        'form-error': !(surname.valid || surname.pristine),
                        'form-success': surname.valid
                     }"
                                   [(ngModel)]="user.surname"
                                   #surname="ngModel">
                            <i class="icon-user"></i>
                            <div [hidden]="surname.valid || surname.pristine"
                                 class="form-error valid">
                                Il cognome è richiesto.
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="email" class="col-sm-3 control-label">E-Mail *</label>
                        <div class="col-sm-6 prepend-icon">
                            <input type="email"
                                   id="email"
                                   name="email"
                                   class="form-control"
                                   placeholder="Inserisci E-Mail..."
                                   pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$"
                                   required
                                   autocomplete="off"
                                   [ngClass]="{
                                        'form-error': !(email.valid || email.pristine),
                                        'form-success': email.valid
                                     }"
                                   [(ngModel)]="user.email"
                                   #email="ngModel">
                            <i class="fa fa-at"></i>
                            <div [hidden]="email.valid || email.pristine"
                                 class="form-error valid">
                                Inserisci un'email valida.
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="phone-number" class="col-sm-3 control-label">Numero di Cellulare</label>
                        <div class="col-sm-6 prepend-icon">
                            <input type="text"
                                   id="phone-number"
                                   name="phone-number"
                                   class="form-control"
                                   placeholder="Inserisci Numero di Cellulare..."
                                   autocomplete="off"
                                   [ngClass]="{
                        'form-success': user.tel !== '' && user.tel !== null
                     }"
                                   [(ngModel)]="user.tel">
                            <i class="glyphicon glyphicon-phone"></i>
                        </div>
                    </div>

                    <div class="text-center  m-t-20">
                        <button type="submit"
                                class="btn btn-embossed btn-primary"
                                [disabled]="!loginForm.form.valid || (user.fk_id_role === 4 && user.fk_id_pa === null)">
                            <i class="icon-plus"></i> Crea Nuovo Utente
                        </button>
                    </div>

                    <div [hidden]="userCreationResult" class="alert alert-danger" style="margin-top: 10px;">
                        Si è verificato un errore, si prega di riprovare.
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
